import { useCallback, useState } from 'react'

export const useSweepsKycModal = () => {
  const kycModalDefaultOptions = {
    onKycCompleted: () => {},
    onKycModalClose: () => {},
    onKycContactLinkClick: () => {},
    showRedemptionOptionsModal: () => {}
  }

  const [showKycModal, setShowKycModal] = useState(false)
  const [kycModalOptions, setKycModalOptions] = useState(kycModalDefaultOptions)

  const openKycModal = useCallback(kycModalOptions => {
    setShowKycModal(true)

    if (kycModalOptions) {
      setKycModalOptions({ ...kycModalDefaultOptions, ...kycModalOptions })
    }
  }, [])

  const closeKycModal = useCallback(() => {
    setShowKycModal(false)

    setKycModalOptions(kycModalDefaultOptions)
  }, [kycModalDefaultOptions])

  return { kycModalOptions, openKycModal, showKycModal, closeKycModal }
}
